<template>
    <div>
        <div>
            <View
                :dataViewDokumenPengadaan="dataViewDokumenPengadaan"
                action="view"
                :header="false"
            >
            </View>
        </div>

        <Divider />
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8" v-if="dataViewDokumenPengadaan.tahap == 'verifikasi_dokumen_pengadaan_1f'">
            <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                <FormVerifikasiHps :approval_hps="form_approval.approval_hps" @update:approval_hps="handleHpsUpdate"/>
            </div>
        </div>  
        <Divider />
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
            <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                <section class="text-gray-600 body-font">
                    <div class="container px-5 py-5 mx-auto">
                        <div class="flex flex-wrap w-full mb-5 flex-col">
                            <div v-show="!loadingApproval">
                                <div class="field grid">
                                    <JetLabel
                                        class="w-1/3 my-2 text-lg font-bold"
                                        for="total_hps"
                                        value="Approval :"
                                    />
                                    <Divider />
                                </div>
                                <div class="field grid">
                                    <label
                                        for="nomor"
                                        class="col-12 mb-2 md:col-2 md:mb-0"
                                    >
                                        Catatan :
                                    </label>
                                    <div class="col-8 md:col-8">
                                        <Textarea
                                            :cols="30"
                                            :rows="5"
                                            :autoResize="true"
                                            class="col-12"
                                            v-model="form_approval.catatan"
                                        />
                                    </div>
                                </div>
                                <div class="field grid">
                                    <div class="col-offset-2 col-8 mt-8">
                                        <div class="flex align-items-center justify-content-center gap-2">
                                            <Button
                                                icon="pi pi-check"
                                                label="Terima"
                                                class="p-button-success"
                                                @click="initiateApproval(true, 'setujui')"
                                            />
                                            <Button
                                                v-if="!isInApprovalWithoutTolakPhase"
                                                icon="pi pi-times"
                                                label="Tolak"
                                                class="p-button-danger"
                                                @click="initiateApproval(true, 'tolak')"
                                            />
                                            <Button
                                                icon="pi pi-times"
                                                label="Batal"
                                                class="p-button-secondary"
                                                @click="$emit('closemodal')"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="field grid" v-show="loadingApproval">
                            <div class="col-12">
                                <ProgressBar
                                    mode="indeterminate"
                                    style="height: 0.5em"
                                />
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
        <Dialog 
            v-model:visible="showConfirmDialog" 
            :modal="true"
            :closable="false"
            :style="{ width: '450px' }"
            header="Konfirmasi">
            <div class="confirmation-content">
                <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
                <span>{{ getConfirmationMessage() }}</span>
            </div>
            <div class="mt-4">
                <p v-if="cooldownActive" class="text-sm text-gray-500 text-center">
                    Mohon tunggu {{ currentCountdown }} detik sebelum konfirmasi...
                </p>
            </div>
            <template #footer>
                <div class="flex justify-content-center gap-2">
                    <Button 
                        label="Batal" 
                        @click="cancelApproval" 
                        class="p-button-text" 
                        :disabled="cooldownActive"
                    />
                    <Button 
                        :label="form_approval.approval == 1 ? 'Terima' : 'Tolak'"
                        @click="confirmApproval"
                        :disabled="cooldownActive"
                        :class="form_approval.approval == 1 ? 'p-button-success' : 'p-button-danger'"
                    />
                </div>
            </template>
        </Dialog>
    </div>
</template>

<script>
import axios from "axios";

import AppLayout from "../../Layouts/AppLayout";
import DataTable from "primevue/datatable";
import InputText from "primevue/inputtext";
import Password from "primevue/password";
import Menubar from "primevue/menubar";
import Textarea from "primevue/textarea";
import AppMenuBar from "../../Components/AppMenuBar.vue";
import DropdownWilayah from "../../Components/DropdownWilayah.vue";
import MapInput from "../../Components/MapInput.vue";
import Calendar from "primevue/calendar";
import { FilterMatchMode } from "primevue/api";
import { useForm } from "@inertiajs/inertia-vue3";
import Column from "primevue/column";
import Button from "primevue/button";
import Divider from "primevue/divider";
import Card from "primevue/card";
import DeleteDialog from "../../Components/DeleteDialog";
import { Inertia } from "@inertiajs/inertia";
import MultiSelect from "primevue/multiselect";
import Dropdown from "primevue/dropdown";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import OverlayPanel from "primevue/overlaypanel";
import FileUpload from "primevue/fileupload";
import pdfvuer from "pdfvuer";
import Dialog from "primevue/dialog";
import ProgressBar from "primevue/progressbar";
import AutoComplete from "primevue/autocomplete";
import InputSwitch from "primevue/inputswitch";

import FormVerifikasiHps from "./partials/FormVerifikasiHps.vue";

import View from "./Penyusunan/View.vue";

import JetLabel from "@/Jetstream/Label";

import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

// import PermissionTreeTable from '../../Components/PermissionTreeTable';

export default {
    setup: () => ({ vuelidate: useVuelidate() }),
    name: "Index",
    components: {
        Menubar,
        AppMenuBar,
        DataTable,
        Column,
        Dialog,
        Button,
        InputSwitch,
        ProgressBar,
        Divider,
        Textarea,
        View,
        JetLabel,
        FormVerifikasiHps
    },
    props: {
        uuid: String,
        dataViewDokumenPengadaan: Object,
        errors: Object,
    },
    watch: {},
    data: function () {
        return {
            loadingApproval: false,
            submitted: false,
            form_approval: {
                catatan: null,
                approval: null,
                approval_hps: [],
            },
            form: {},
            showConfirmDialog: false,
            cooldownActive: false,
            currentCountdown: 5,
            approvalWithoutTolakPhases: this.$page.props.appConfig?.kode_tahap_approval_without_tolak || ['verifikasi_berita_acara_pemilihan_penyedia_1f','hasil_pemilihan_penyedia_1f'],
        };
    },
    computed: {
        isInApprovalWithoutTolakPhase() {
            return this.approvalWithoutTolakPhases.includes(this.dataViewDokumenPengadaan.tahap);
        }
    },
    validations() {
        return {
            form_approval: {
                approval: {
                    required,
                },
            },
        };
    },
    methods: {
        getConfirmationMessage() {
            return this.form_approval.approval == 1 
                ? 'Apakah Anda yakin ingin menyetujui dokumen ini?' 
                : 'Apakah Anda yakin ingin menolak dokumen ini?';
        },
        initiateApproval(isFormValid, action) {
            // If the current phase doesn't allow rejection, force approval to be "setujui"
            if (this.isInApprovalWithoutTolakPhase) {
                action = 'setujui';
            }
            
            this.form_approval.approval = action === 'setujui' ? 1 : 0;
            this.showConfirmDialog = true;
            this.cooldownActive = true;
            this.currentCountdown = 5;

            const timer = setInterval(() => {
                this.currentCountdown--;
                if (this.currentCountdown <= 0) {
                    this.cooldownActive = false;
                    clearInterval(timer);
                }
            }, 1000);
        },
        confirmApproval() {
            this.approveForm(true);
        },
        cancelApproval() {
            this.showConfirmDialog = false;
            this.cooldownActive = false;
        },
        async approveForm(isFormValid) {
            if (!isFormValid) {
                return;
            }

            this.loadingApproval = true;
            try {
                const response = await axios.post(
                    route("dokumen_pengadaan.approval", {
                        uuid: this.uuid,
                    }),
                    this.form_approval
                );

                // Success message handling
                if (response.data.message) {
                    this.$toast.add({
                        severity: "success",
                        summary: "Berhasil!",
                        detail: response.data.message,
                        life: 3000,
                    });
                }
                
                this.$emit("closemodal");
                window.location.reload();
            } catch (error) {
                console.error("Error during approval:", error);
                this.$toast.add({
                    severity: "error",
                    summary: "Error!",
                    detail: "Terjadi kesalahan saat memproses approval",
                    life: 3000,
                });
            } finally {
                this.loadingApproval = false;
                this.showConfirmDialog = false;
            }
        },
        handleHpsUpdate(newHpsData) {
            this.form_approval.approval_hps = newHpsData;
            // Check if any HPS item has catatan
            const hasNotes = newHpsData.some(item => item.catatan && item.catatan.trim() !== '');
            if (hasNotes) {
                this.form_approval.approval = '0';  // Set to reject (0) when HPS has notes
            }
        },
        // openPdfViewer(pdf_url) {
        //     var pdf_data = pdfvuer.createLoadingTask(pdf_url);
        //     pdf_data.then((pdf) => {
        //         this.num_pdf_page = pdf.numPages;
        //         console.log(pdf.numPages);
        //     });
        //     this.displayPdfViewer = true;
        // },
        // closePdfViewer() {
        //     this.displayPdfViewer = false;
        // },
    },
    mounted() {
        // console.log('dataViewDokumenPengadaan', this.dataViewDokumenPengadaan);
        if (this.dataViewDokumenPengadaan.tahap == 'verifikasi_dokumen_pengadaan_1f') {
            this.form_approval.approval_hps = this.dataViewDokumenPengadaan.detail_hps.map(hps => ({ ...hps, catatan: '' }));
        }
    },
    created() {
        this.form = this.dataViewDokumenPengadaan;
    },
    watch: {
        'dataViewDokumenPengadaan.detail_hps'(newVal) {
            // Check if any detail HPS has catatan
            const hasNotes = newVal.some(item => item.catatan && item.catatan.trim() !== '');
            if (hasNotes) {
                this.form_approval.approval = 'ditolak';
            }
        }
    }
};
</script>

<style lang="css" scoped>
.red-radiobutton {
    border-color: #a61900;
    /* background: #a60000; */
}

.red-radiobutton.p-radiobutton-checked .p-radiobutton-box.p-highlight {
    border-color: #a61900 !important;
    background: #a60000 !important;
}
</style>
